import React from 'react';
// import TagsInput from 'react-tagsinput';
import ReactTagInput from '@pathofdev/react-tag-input';
import { map, includes, filter, cloneDeep } from 'lodash';

import { MdClose as CloseIcon } from 'react-icons/md';

import styles from './talent.module.scss';
import { apiUrls } from '../../constants/apiurls';
import { Spinner } from '../loader/loader';
import tags from '../../redux/modules/tags';
import { useState } from 'react';
import { useEffect } from 'react';
import dataService from '../../services/dataService';
import toast from 'react-hot-toast';
import parseError from '../../services/errorParser';

// const renderTalentTag = ({
//   tag,
//   key,
//   disabled,
//   onRemove,
//   classNameRemove,
//   getTagDisplayValue,
//   ...other
// }) => (
//   <span key={key} {...other}>
//     <span className={styles.talentTagLabel}>{getTagDisplayValue(tag)}</span>
//     {!disabled && (
//       <a className={classNameRemove} onClick={() => onRemove(key)}>
//         <CloseIcon size={16} />
//       </a>
//     )}
//   </span>
// );

export const TalentTags = ({ onAdd, onRemove, userId }) => {
  const [parsedTags, setParsedTags] = useState([]);

  const KeyCodes = {
    comma: 188,
    enter: 13,
  };

  const delimiters = [KeyCodes.comma, KeyCodes.enter];

  const {
    data: tagsData,
    isFetching: isTagsLoading,
    error: tagsError,
    isSuccess: tagsSuccess,
  } = tags.list().useTaglistQuery({ extendedPath: apiUrls.getTags() });

  const [createTag, tagsCreateData] = tags.form().useTagcreateMutation();
  const [deleteTag, tagsDeleteData] = tags.delete().useTagdeleteMutation();

  useEffect(() => {
    if (tagsData?.data?.length) {
      let result = dataService.parseTagsForTalent(tagsData?.data, userId);

      setParsedTags(result);
    }
  }, [tagsData?.data]);

  useEffect(() => {
    if (tagsCreateData.isSuccess) {
      if (tagsCreateData?.date?.errors) {
        toast.success(parseError(tagsCreateData?.date?.errors));
        return;
      }

      toast.success('Tag Created Successfully!');
    }
    if (tagsCreateData.error) {
      toast.error('Failed To Create Tags!');
    }
  }, [tagsCreateData]);

  useEffect(() => {
    if (tagsDeleteData.isSuccess) {
      toast.success('Tag Deleted!');
    }
    if (tagsDeleteData.error) {
      toast.error('Failed  To Delete Tag!');
    }
  }, [tagsDeleteData]);

  const handleDelete = (i) => {
    deleteTag({
      body: {
        id: parsedTags[i].id,
      },
    });
  };

  const handleAddition = (tag) => {
    createTag({
      body: {
        name: tag.text,
        users: [
          {
            id: userId,
          },
        ],
      },
    });
  };

  const handleDrag = (tag, currPos, newPos) => {
    let newTags = cloneDeep(parsedTags);

    newTags.splice(currPos, 1);
    newTags.splice(newPos, 0, tag);
    setParsedTags(newTags);
  };

  return (
    <>
      {isTagsLoading ? (
        <Spinner height={40} width={40} />
      ) : (
        <div className={styles.talentTags}>
          <ReactTagInput
            tags={(parsedTags || []).map(tag => tag.text)}
            onChange={(tags) => {
              // Handle tag addition
              const currentTexts = (parsedTags || []).map(tag => tag.text);
              const newTags = tags.filter(tag => !currentTexts.includes(tag));
              
              if (newTags.length > 0) {
                // Take the last added tag
                const newTag = newTags[newTags.length - 1];
                handleAddition({ text: newTag });
              }
              
              // Handle tag deletion
              if (tags.length < currentTexts.length) {
                // Find which tag was removed
                for (let i = 0; i < parsedTags.length; i++) {
                  if (!tags.includes(parsedTags[i].text)) {
                    handleDelete(i);
                    break;
                  }
                }
              }
            }}
            placeholder="Add Tags"
          />
        </div>
      )}
    </>
  );
};
